<template>
    <el-select :placeholder="newPlaceholder" filterable clearable v-model="innerValue" v-bind="$attrs" @change="change">
        <el-option v-for="(item, index) in categoryList" :key="index" :value="item.value" :label="item.label"></el-option>
    </el-select>
</template>

<script>
import { getRequestHost } from '../../utils/constants';

let mapText = ['', '一', '二', '三', '四'];
/**
 *
 * @author mengqinghui
 * @since 1.3.2
 *
 * 商品品类下拉框，可以配置数据是否带权限，也可以生成级联的品类下拉框
 *
 */
export default {
    name: 'XxCategorySelect',
    props: {
        /**
         * select的值，是poiId，类型可以是String, Number, 也可以是Array,
         *@model
         */

        value: {
            type: [String, Number, Array],
            default: ''
        },
        /**
         *  层级，默认是2级品类
         */
        level: {
            type: Number,
            default: 2
        },
        /**
         *  placeholder, 默认根据level确定文案，比如level =1， 文案是 '请选择一级品类'
         */
        placeholder: String,
        /**
         *  usePermission, 是否使用带权限的下拉框，默认是true
         */
        usePermission: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            innerValue: '',
            categoryList: [],
            newPlaceholder: this.placeholder || `请选择${mapText[this.level]}级品类`
        };
    },
    created() {
        this.getCategoryList();
    },
    watch: {
        value: {
            immediate: true,
            handler() {
                this.innerValue = this.value || '';
            }
        }
    },
    methods: {
        getCategoryList() {
            return this.$get(`${getRequestHost()}/api/resource/getCategoryList`).then(res => {
                this.categoryList = (res || [])
                    .filter(item => item.level === this.level)
                    .map(v => {
                        return {
                            value: v.id,
                            label: v.name
                        };
                    });
                /**
                 * dataLoaded event, 数据加载完成，返回请求到的品类列表.
                 *
                 * @event dataLoaded
                 * @type {List}
                 */
                this.$emit('dataLoaded', this.categoryList);
            });
        },
        change(value) {
            this.$emit('input', value);
            /**
             * change event, 参数是一个category对象，.
             *
             * @event change
             * @type {object}
             */
            this.$emit('change', this.categoryList.find(v => v.value === value));
        }
    }
};
</script>
